import React, { Component } from 'react';
import Button from '~/UI/Button';

import styles from './styles.less';

interface Props {
	count?: number | null;
	onLoadMore(): void;
}

export default class SimplePaginator extends Component<Props> {
	render() {
		const { count, onLoadMore } = this.props;

		return (
			<div className={styles.container}>
				<Button onClick={onLoadMore}>Load {count !== null ? `${count} ` : ''}more</Button>
			</div>
		);
	}
}
